import { Component } from '@angular/core';
import { ViewDidEnter } from "../../app/app.interfaces";
import { PageTitleService } from "../../services/page-title.service";
import { EventService } from "../../services/event.service";
import { IonicHelper } from "../../helpers/ionic.helper";

@Component({
  selector: 'notifications-page',
  templateUrl: 'notifications-page.html'
})

export class NotificationsPage implements ViewDidEnter{

	constructor(private pageTitleService: PageTitleService,
							private ionic: IonicHelper,
							private eventService: EventService){

	}

	ionViewDidEnter(): void{

		this.pageTitleService.setPageTitle('notifications');


	}

}



// WEBPACK FOOTER //
// ./src/components/notifications-page/notifications-page.ts